import { CartPrescriptionDetailProps } from '../interface/interface';

export const CartPrescriptionDetail = ({
  label,
  value,
  className,
}: CartPrescriptionDetailProps) => {
  return (
    <div className={`flex flex-col cart-presc-detail ${className}`}>
      <label className="text-base font-semibold text-secondary-pink-700 mb-3">
        {label}
      </label>
      <p className="text-sm font-regular text-primary-blue-500">{value}</p>
    </div>
  );
};
